import Vue from "vue";
import Component from "vue-class-component";
import { Client } from "@/api/profile";
import REQ_URL from "@/consts/req-url";
import ClientFilterPanel from "../ClientFilterPanel/ClientFilterPanel";
import ClientSortPanel from "../ClientSortPanel/ClientSortPanel";
import ClientList from "../ClientList/ClientList";
import ClientTable from "../ClientTable/ClientTable";
import { Watch } from "vue-property-decorator";
import { PagedResponse } from "@/types/response-data";
import { modalParams } from "@/types/state.modal";
import isIntoView from "@/api/isIntoView";
interface FilterParams {
  search: string;
}

@Component({
  components: {
    ClientFilterPanel,
    ClientSortPanel,
    ClientList,
    ClientTable,
  },
})
export default class ClientListContainer extends Vue {
  loading = true;
  filterTimerId: null | number = null
  sortBy = "name_asc";
  pageInfoPrev = {
    curr: 1,
    of: 1,
  };
  pageInfo = {
    curr: 1,
    of: 1,
  };
  filterParams: FilterParams = {
    search: "",
  };

  viewListMode = localStorage.getItem("clientViewListMode")
    ? localStorage.getItem("clientViewListMode")
    : "list";
  clients: Client[] = [];
  error = "";
  get pageVisible() {
    return this.$vuetify.breakpoint.xsOnly ? 6 : 7;
  }
  get compViewListMode() {
    return this.$vuetify.breakpoint.xsOnly ? "grid" : this.viewListMode;
  }
  @Watch("viewListMode") onViewListModeChange(val: string) {
    localStorage.setItem("clientViewListMode", val);
  }
  async filtering(needScroll = false) {
    this.loading = true;
    try {
      let data = await this.$fetch<PagedResponse<Client[]>>(
        REQ_URL.GET_CLIENTS,
        {
          method: "POST",
          body: JSON.stringify({
            filterParams: this.filterParams,
            page: this.pageInfo.curr,
            sortBy: this.sortBy,
          }),
        }
      );
      if (data.body) {
        this.clients = data.body.pageContent;
        if (data.body.pageInfo) {
          this.pageInfoPrev.curr = this.pageInfo.curr = data.body.pageInfo.curr;
          this.pageInfoPrev.of = this.pageInfo.of = data.body.pageInfo.of;
        } else this.pageInfo.curr = this.pageInfo.of = 1;

        if (needScroll) {
          let tb = document.getElementById("toolbar");
          if (tb && !isIntoView("#clients")) {
            this.$vuetify.goTo("#clients", {
              duration: 300,
              offset: (tb && tb.offsetHeight ? tb.offsetHeight : 0) + 30,
              //easing: this.easing
            });
          }
        }
      } else
        throw new Error(
          data.error ? data.error : "Ошибка соединения. Повторите позже."
        );
    } catch (error) {
      this.pageInfo.curr = this.pageInfoPrev.curr;
      this.pageInfo.of = this.pageInfoPrev.of;

      let errMsg: modalParams = {
        type: "error",
        msg: error.message,
      };
      this.$store.commit("modal:open", errMsg);
    }
    this.loading = false;
  }
  updateFilterParams(s: string) {
    this.filterParams.search = s;
    this.filterTimerId !== null && clearTimeout(this.filterTimerId)
    this.filterTimerId = setTimeout(() => {
      this.pageInfo.curr = 1;
      this.updateQueryState();
      this.filtering();
    }, 500)
  }
  updatePage(e: number) {
    this.pageInfo.curr = e;
    this.updateQueryState();
    this.filtering(true);
  }
  updateSortBy(e: string) {
    this.sortBy = e;
    this.updateQueryState();
    this.filtering();
  }
  initState() {
    this.sortBy =
      typeof this.$route.query.sortBy === "string"
        ? this.$route.query.sortBy
        : "name_asc";
    this.pageInfo.curr =
      typeof this.$route.query.p === "string" ? +this.$route.query.p : 1;
    this.filterParams.search =
      typeof this.$route.query.s === "string" ? this.$route.query.s : "";
  }
  updateQueryState() {
    const newQueryState = {
      s: this.filterParams.search,
      sortBy: this.sortBy,
      p: this.pageInfo.curr + "",
    }
    history.pushState(
      {},
      '',
      this.$route.path +
        "?" +
        Object.keys(newQueryState)
          .map((key) => {
            return (
              encodeURIComponent(key) + "=" + encodeURIComponent((newQueryState as any)[key])
            );
          })
          .join("&")
    );
  }
  onHistoryNav() {
    this.initState();
    this.filtering();
  }
  initHistoryWatcher() {
    window.addEventListener('popstate', this.onHistoryNav)
  }
  mounted() {
    this.initState();
    this.filtering();
    this.initHistoryWatcher()
  }
}
